import { Controller } from "@hotwired/stimulus"
import { requestConfirm, pluralize } from "../util"

const LIMIT_TYPES = ["none", "week"]

export default class extends Controller {
  static targets = [
    "form", "confirmButton",
    "hoursInput", "minutesInput", "limitTypeInput"
  ]
  static values = {
    usersCount: Number,
    prefillLimitType: { type: String, default: "none" }
  }

  connect() {
    this.updateConfirmButtonState()
  }

  confirmTimeLimits(event) {
    event.preventDefault()

    this.requestConfirmAndSubmit(
      "confirm-users-time-limits",
      this.buildTimeLimitsModalData()
    )
  }

  onTabChanged(event) {
    const limitType = LIMIT_TYPES[event.detail.selectedIndex]
    this.updateLimitTypeInput(limitType)
    this.clearTimeInputs()
    this.updateConfirmButtonState()
  }

  onHoursInput() {
    this.setDefaultCompanionInput(this.hoursInputTarget, this.minutesInputTarget)
    this.updateConfirmButtonState()
  }

  onMinutesInput() {
    this.setDefaultCompanionInput(this.minutesInputTarget, this.hoursInputTarget)
    this.updateConfirmButtonState()
  }

  updateLimitTypeInput(limitType) {
    if (this.hasLimitTypeInputTarget) {
      this.limitTypeInputTarget.value = limitType
    }
  }

  updateConfirmButtonState() {
    if (!this.hasConfirmButtonTarget) return

    const limitType = this.getSelectedLimitType()

    if (limitType === "week") {
      this.confirmButtonTarget.disabled = !this.hasValidTimeInputs()
      return
    }

    this.confirmButtonTarget.disabled = false
  }

  async requestConfirmAndSubmit(modal, data) {
    const confirmed = await requestConfirm({ modal, data })
    if (!confirmed) return

    this.submitFormAndClose()
  }

  submitFormAndClose() {
    this.formTarget.requestSubmit()
    this.element.dispatchEvent(new CustomEvent("drawer:close", { bubbles: true }))
    this.element.dispatchEvent(new CustomEvent("table-checkboxes:clear", { bubbles: true }))
  }

  buildTimeLimitsModalData() {
    const usersLabel = pluralize(this.usersCountValue, "User", "Users")
    const limitType = this.getSelectedLimitType()

    if (limitType === "none") {
      return {
        title: `Remove time limits for ${usersLabel}`,
        text: "Time limits will be removed for selected ambassadors."
      }
    }

    const hours = this.hoursInputTarget.value
    const minutes = this.minutesInputTarget.value

    return {
      title: `Update time limits for ${usersLabel}`,
      text: `Set a time limit of ${pluralize(hours, "hour", "hours")} and ${pluralize(minutes, "minute", "minutes")} per week`
    }
  }

  getSelectedLimitType() {
    if (this.hasLimitTypeInputTarget) {
      return this.limitTypeInputTarget.value
    }
    return null
  }

  hasValidTimeInputs() {
    return this.hasHoursInputTarget &&
      this.hasMinutesInputTarget &&
      this.hoursInputTarget.value !== "" &&
      this.minutesInputTarget.value !== ""
  }

  setDefaultCompanionInput(changedInput, companionInput) {
    if (changedInput.value && !companionInput.value) {
      companionInput.value = 0
    }
  }

  clearTimeInputs() {
    if (this.hasHoursInputTarget) this.hoursInputTarget.value = ""
    if (this.hasMinutesInputTarget) this.minutesInputTarget.value = ""
  }
}
